import { render, staticRenderFns } from "./AdminDiagnostic.vue?vue&type=template&id=36d07ddf"
import script from "./AdminDiagnostic.vue?vue&type=script&lang=js"
export * from "./AdminDiagnostic.vue?vue&type=script&lang=js"
import style0 from "./AdminDiagnostic.vue?vue&type=style&index=0&id=36d07ddf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAvatar,VBtn,VCard,VIcon,VTab,VTabItem,VTabs,VTabsItems})
